import { BaseApi, ApiResponse } from "../utils/request";

// Android App 信息
export interface AndroidAppInfo {
  apkLink?: string;
  version?: string;
  size?: string;
}

// iOS App 信息
export interface IosAppInfo {
  apkLink: string;
  version?: string;
  size?: string;
}

/**
 * Global API 类
 * 继承 BaseApi，提供全局相关的 API 接口
 */
export class GlobalApi extends BaseApi {
  constructor() {
    super();
  }

  /**
   * 获取 Android App 下载信息
   * @returns Promise<ApiResponse<AndroidAppInfo, true>>
   */
  async getAndroidAppInfo(): Promise<ApiResponse<AndroidAppInfo, true>> {
    return this.post<AndroidAppInfo, true>("/api/app/app_info", {});
  }

  /**
   * 获取 iOS App 下载信息
   * @returns Promise<ApiResponse<IosAppInfo, true>>
   */
  async getIosAppInfo(): Promise<ApiResponse<IosAppInfo, true>> {
    return this.post<IosAppInfo, true>("/api/app/ios_app_info", {});
  }
}

export const globalApi = new GlobalApi();
export const getAndroidAppInfo = () => globalApi.getAndroidAppInfo();
export const getIosAppInfo = () => globalApi.getIosAppInfo();
